/**
 * Chat transcript windows — shared between the api `Chat.parts` resolver and every
 * client / town-square document that selects `parts(last: ...)`.
 *
 * Sized against the measured average `pg_column_size` of a live `chat_parts` row:
 * - CHAT_PARTS_DEFAULT = min(200, floor(1,500,000 / avg)), down to a multiple of 25
 * - CHAT_PARTS_MAX = min(500, floor(4,000,000 / avg)), down to a multiple of 25
 * - CHAT_PARTS_LEGACY_DEFAULT = clamp(floor(5,000,000 / (CHATS_LEGACY_CAP x avg)), 5, 20)
 *
 * Never pass a literal number for `last` — import these.
 */

/** Parts in one opened chat when `last` is omitted. */
export const CHAT_PARTS_DEFAULT = 200;

/** Upper bound for `last` on a single opened chat. */
export const CHAT_PARTS_MAX = 500;

/** Parts per chat on any list row (`chats`, `myChats`, `adminChats`) — `last` cannot raise it. */
export const CHAT_PARTS_LEGACY_DEFAULT = 20;

/** Newest chats the deprecated `Query.chats` list returns. */
export const CHATS_LEGACY_CAP = 50;

/** Chats per `myChats` page when `first` is omitted — the page size every list requests. */
export const CHATS_PAGE_DEFAULT = 50;

/** Upper bound for `first` on one `myChats` page. */
export const CHATS_PAGE_MAX = 100;
